import Keycloak from 'keycloak-js';
import env from '@/util/env';

const keycloak = new Keycloak({
  clientId: 'px-web',
  realm: env.KEYCLOAK_REALM,
  url: env.KEYCLOAK_URL,
});

export default keycloak;
